import FindOrdersPage from './FindOrdersPage'

export default FindOrdersPage
